import React from 'react';
import { toast } from 'react-toastify';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import store from 'store';
import AuthService from '../services/AuthService';

const Template = ({ title, body, type }) => {
  let icon;
  switch (type) {
    case 'success':
      icon = 'fas fa-check-circle';
      break;
    case 'warn':
      icon = 'fas fa-exclamation-triangle';
      break;
    case 'error':
      icon = 'fas fa-exclamation-circle';
      break;
    case 'info':
    default:
      icon = 'fas fa-info-circle';
  }

  let toastBody = body;

  if (typeof toastBody === 'number') {
    toastBody = String(toastBody);
  } else if (!React.isValidElement(toastBody)) {
    if (typeof toastBody !== 'string') {
      try {
        toastBody = JSON.stringify(toastBody);
      } catch (e) {
        console.warn(e);
        toastBody = 'Unknown';
      }
    }
  }

  return (
    <div className={classNames('toast-wrapper')}>
      <div className="toast-icon">
        <i className={icon} />
      </div>
      <div className="toast-content">
        <div className="toast-title">{title}</div>
        <div className="toast-body">{toastBody}</div>
      </div>
    </div>
  );
};

Template.propTypes = {
  title: PropTypes.string,
  body: PropTypes.any,
  type: PropTypes.string,
};

const typeWeights = {
  success: 0,
  info: 1000,
  warn: 0,
  error: 3000,
};

const actions = {};

const getAutoCloseTime = (body = '') => {
  const base = 2000;
  return base + body.length * 8;
};

const addToast = toastMeta => {
  const current = store.get('toasts');
  const payload = JSON.stringify(toastMeta);
  if (!current || !Array.isArray(current)) {
    store.set('toasts', [payload]);
    return;
  }

  store.set('toasts', [payload, ...current].slice(0, 25));
};

const handler = (title, body, options = {}, type) => {
  const override = options.autoClose || options.timeOut;
  const autoClose = override || getAutoCloseTime(body) + typeWeights[type];
  const userId = AuthService.getUser().id;

  const timestamp =  Math.round((new Date()).getTime());
  const location = window.location.pathname;
  const toastMeta = { title, body, type, id: `${timestamp}:${userId}`, timestamp, location };

  if (!options.skipLog) {
    addToast(toastMeta);
  }

  return toast[type](<Template title={title} body={body} type={type} />, { autoClose, ...options });
};

actions.success = (title, body, options) => {
  return handler(title, body, options, 'success');
};

actions.info = (title, body, options) => {
  return handler(title, body, options, 'info');
};

actions.warn = (title, body, options) => {
  return handler(title, body, options, 'warn');
};

actions.error = (title, body, options) => {
  return handler(title, body, options, 'error');
};

actions.update = (...args) => {
  return toast.update(...args);
};

export default actions;
